<div class="container">
  <rd-shared-breadcrumb
    [breadcrumbText]="'redeem_cash_v2.back_to_checkout' | translate"
    [loading]="false"
    [redirectURL]="backUrl"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'">
  </rd-shared-breadcrumb>
  <div
    class="review-body-wrapper"
    *ngIf="redeemCashLoyaltyProgram$ | async as redeemCashLoyaltyProgram">
    <rd-rcv2-review-body
      [formData]="checkoutFormData$ | async"
      [redeemCashLoyaltyProgram]="redeemCashLoyaltyProgram"
      [cashRedemptionLoading]="checkoutCashRedemptionLoading$ | async"
      [promocode]="promocode$ | async"
      [promocodeUsage]="promocodeUsage$ | async"
      [promocodeLoading]="promocodeLoading$ | async"
      [promocodeHttpError]="promocodeError$ | async"
      (submitCashRedemption)="submitCashRedemption($event)"
      (applyPromocode)="handleApplyPromocode($event)"
      [redeemCashMembership]="redeemCashMembership$ | async">
    </rd-rcv2-review-body>
  </div>
</div>
